import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function FAQs() {
  return (
    <main className="content-for-layout" role="main">
      <div className="policy__container">
        <div className="policy__title">
          <h1>Frequently asked questions</h1>
        </div>
        <div className="policy__body">
          <div className="rte">
            <p>SHOPPING WITH DILVERBLOOM</p>
            <p>
              <strong>How can I place an order?</strong><br />
              Choose a product, add it to your cart, and follow the checkout
              steps. Review your contact and delivery details before submitting
              the order.
            </p>
            <p>
              <strong>Can I change or cancel an order?</strong><br />
              Email build@dilverbloom.online as soon as possible. We will try to
              help before fulfillment begins, but changes cannot be guaranteed
              after an order has been prepared or dispatched.
            </p>
            <p>
              <strong>Where can I find shipping estimates?</strong><br />
              Delivery timing and shipping information are available on our{" "}
              <Link to="/shipping">Shipping page</Link>.
            </p>
            <p>
              <strong>What is the return process?</strong><br />
              Eligibility, time limits, and return instructions are listed in
              our <Link to="/returns">Returns Policy</Link>.
            </p>
            <p>
              <strong>What should I do if my order arrives damaged?</strong><br />
              Contact us promptly at build@dilverbloom.online with your order
              details and clear photos of the item and outer packaging.
            </p>
            <p>
              <strong>How should food products be stored?</strong><br />
              Follow the storage and handling directions on the product
              packaging. If an item requires special care after delivery, keep
              it sealed and store it as directed.
            </p>
            <p>
              <strong>How can I contact dilverbloom?</strong><br />
              Visit our <Link to="/contact">Contact Us page</Link> or email
              build@dilverbloom.online.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default FAQs;
